<template>
  <div class="route-list">
    <div
      v-for="route in filteredRoutes"
      :key="route.id"
      class="route-item"
      @mouseover="showAction = route.id"
      @mouseleave="showAction = null"
    >
      <div
        class="route-item-content"
        @click="onRouteSelected(route)"
      >
        <div class="route-title">
          {{
            route.description != ""
              ? route.description
              : "No description provided"
          }}
        </div>

        <div class="route-subtitle">
          <v-icon
            small
            class="mr-1"
          >
            mdi-calendar
          </v-icon>
          <span class="route-subtitle-text">
            {{ formatDateTimeString(route.creationDate) }}
          </span>
        </div>
      </div>

      <div>
        <v-btn
          v-if="showAction == route.id"
          icon
          @mouseover="enableAction = true"
          @mouseleave="enableAction = false"
          @click="onDeleteIconPressed(route)"
        >
          <v-icon :color="getDeleteIconColor">
            mdi-delete-outline
          </v-icon>
        </v-btn>
      </div>
    </div>
    <v-dialog
      v-model="dialog"
      max-width="300px"
      max-height="100"
    >
      <v-card class="px-4">
        <v-card-title
          class="mt-2"
        >
          <v-row>
            <v-icon
              class="mr-1"
              color="blue"
            >
              mdi-trash-can
            </v-icon>
            Delete route
          </v-row>
        </v-card-title>

        <v-card-text style="height: 100px">
          <v-col class="mt-1 pa-0">
            <p>Are you sure you want to delete the route</p>
          </v-col>
          <v-col class="mt-1 pa-0">
            <p>{{ selectedRouteText }}</p>
          </v-col>
        </v-card-text>
        <v-col>
          <v-row>
            <v-btn
              color="primary"
              rounded
              block
              class="mb-2"
              @click="
                onConfirmDeletePressed(selectedRoute.id, selectedRoute.theyrId)
              "
            >
              Delete
            </v-btn>
          </v-row>
          <v-row>
            <v-btn
              color="primary"
              class="mr-2"
              text
              rounded
              block
              @click="dialog = false"
            >
              Cancel
            </v-btn>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { formatDateTimeString } from "../../../../helper_functions/date_time_formats";
export default {
  name: "RoutesSuccess",
  data: () => ({
    showAction: false,
    enableAction: false,
    dialog: false,
    selectedRoute: "",
  }),
  computed: {
    ...mapState("weatherRouting/routesModule", [
      "filteredRoutes",
      "paginatedFetchLoading",
      "paginatedFetchError",
    ]),
    ...mapState("weatherRouting/formModule", ["currentTab"]),
    getDeleteIconColor() {
      return this.enableAction ? "#E57373" : "#90A4AE";
    },
    selectedRouteText() {
      return this.selectedRoute !== null ? this.selectedRoute.description : "";
    },
  },
  watch: {
    currentTab: {
      handler() {
        this.removeSelectedRoute();
      },
      deep: true,
    },
  },
  methods: {
    formatDateTimeString,
    onDeleteIconPressed(route) {
      this.selectedRoute = route;
      this.dialog = true;
    },
    async onConfirmDeletePressed(routeId, routeTheyrId) {
      await this.$store.dispatch("weatherRouting/routesModule/deleteRoute", {
        routeId: routeId,
        theyrId: routeTheyrId,
      });
      this.dialog = false;
    },
    onRouteSelected(route) {
      this.$store.commit(
        "weatherRouting/routesModule/SET_SELECTED_ROUTE",
        route
      );
    },
    onTextChanged(text) {
      this.$store.dispatch(
        "weatherRouting/routesModule/filterRoutesByDescription",
        {
          description: text,
        }
      );
    },
    removeSelectedRoute() {
      this.$store.commit(
        "weatherRouting/routesModule/SET_SELECTED_ROUTE",
        null
      );
    },
  },
};
</script>

<style scoped>
.route-item {
  cursor: pointer;
  background-color: var(--color-surface);
  border-radius: 8px;
  border: 1px solid var(--color-border);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.route-item:hover {
  border: 1px solid var(--color-secondary);
}
.route-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text);
}
.route-subtitle {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
}

.route-subtitle .v-icon {
  color: var(--color-text) !important;
}

.route-subtitle-text {
  font-size: 12px;
  color: var(--color-text) !important;
}

.route-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 8px;
}
.route-item-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
